module.exports = __webpack_public_path__ + "img/github.08a7dee0.svg";